// The client-report TEMPLATE an account is shown under (2026-11-11, round 3/4 of
// the automotive report brief).
//
// ⚠️ ABSENT IS NOT `standard`. `Account.reportTemplate` absent (or null) means
// "inherit"; only a deliberately chosen value overrides what a parent, the
// marque, the legacy flag or the industry default would say.

export const REPORT_TEMPLATES = ['standard', 'goal_split', 'automotive'] as const;
export type ReportTemplate = (typeof REPORT_TEMPLATES)[number];

/** Client-facing labels. ⚠️ A total record so a fourth template is a compile error here. */
export const REPORT_TEMPLATE_LABELS: Record<ReportTemplate, string> = {
  standard: 'Standard',
  goal_split: 'Goal split',
  automotive: 'Automotive',
};

export function isReportTemplate(v: unknown): v is ReportTemplate {
  return typeof v === 'string' && (REPORT_TEMPLATES as readonly string[]).includes(v);
}

/**
 * WHERE a resolved template came from — the account page names the level that
 * won ("Automotive (from Servco group)").
 *
 *  own      the account's own `reportTemplate`
 *  parent   the nearest ancestor on the parent chain (a group, usually)
 *  marque   the account's `brandAccountId` pointer (Toyota, Kia…)
 *  legacy   the old brand-level `portalMetaGoalReport` tick → goal_split
 *  industry the automotive industry default (only with the flag on)
 *  default  nothing was set anywhere → standard
 */
export type ReportTemplateSource = 'own' | 'parent' | 'marque' | 'legacy' | 'industry' | 'default';
